exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.pic_left[data-v-f82727b4] {\n}\n", ""]);
